
export function formatData(response) {

  const calculatesameAccNumberTransactions = (transactions) => {
    const aggregatedTransactions = transactions.reduce((result, transaction) => {
      const { accountNumber, debits, credits } = transaction;
      if (!result[accountNumber]) {
        result[accountNumber] = { ...transaction };
      } else {
        result[accountNumber].debits += debits;
        result[accountNumber].credits += credits;
      }
      return result;
    }, {});

    return Object.values(aggregatedTransactions);
  }

  let formatedData = [];
  // Balance sheet main classes  =  1 ASSETS - Pasurit  2 LIABILITIES - detyrimet and 3 EQUITY - Ekuiteti
  let mainClasses = [
    { groups: [400, 460], name: "Të Hyrat", calculateId: 1, saldo: "credits" },
    { groups: [500, 560], name: "Kostoja e shitjes", calculateId: 1, saldo: "credits" },
    { name: "Fitimi / (humbja) bruto", bold: true, calculateTotalId: 1, calculateId: 2 },
    { groups: [402], range: [459], name: "Të ardhurat tjera", calculateId: 2, saldo: "credits" },
    { groups: [600], range: [649], name: "Shpenzimet e shpërndarjes", calculateId: 2, saldo: "credits" },
    { groups: [650], range: [669], name: "Shpenzimet e administrative", calculateId: 2, saldo: "credits" },
    { groups: [670], range: [699], name: "Shpenzimet e tjera", calculateId: 2, saldo: "credits" },
    { name: "Fitimi / (humbja) operative", bold: true, calculateTotalId: 2, calculateId: 3 },
    { groups: [800], range: [899], name: "Shpenzimet Financiare", calculateId: 3, saldo: "credits" },
    { groups: [461], range: [499], name: "Të ardhurat Financiare", calculateId: 3, saldo: "credits" },
    { name: "Fitimi / (humbja) para tatimit", bold: true, calculateTotalId: 3, calculateId: 4 },
    { groups: [700], range: [799], name: "Shpenzimet e tatimit në fitim", calculateId: 4, saldo: "credits" },
    { name: "Fitimi / (humbja) i/e vitit", bold: true, calculateTotalId: 4, calculateId: 5 }
  ]

  let expandedClasses = [];

  mainClasses.forEach(entry => {
    if (entry.groups && entry.groups.length === 1 && entry.range) {
      let start = entry.groups[0];
      let end = entry.range[0];
      for (let i = start; i <= end; i++) {
        expandedClasses.push({
          groups: [i],
          name: '',
          calculateId: entry.calculateId,
          saldo: entry.saldo
        });
      }
    } else {
      expandedClasses.push(entry);
    }
  });


  expandedClasses.forEach((m) => {
    let mainClass = {}
    if (m?.groups?.length === 2) {
      mainClass.name = m.name;
      mainClass.calculateId = m.calculateId;
      let resultMultipleGroups = 0;
      // for(let g = 0; g < 2; g++){
      //   console.log(m.groups[g])
      // 
      var groupInfo = [];
      m.groups.forEach(g => {
        let gValue = 0;
        if (m.saldo === "credits") {
          gValue = response.filter(i => i.groupId === g).map(i => i.credits - i.debits).reduce((partialSum, a) => partialSum + a, 0);
          if (response.filter(i => i.groupId === g)[0]?.groupName) {

            let obj = { name: response.filter(i => i.groupId === g)[0]?.groupName, grValue: gValue }
            groupInfo.push(obj)
          }
          // let obj = {grName:response.filter(i => i.groupId === g).groupName, }
        } else {
          gValue = response.filter(i => i.groupId === g).map(i => i.debits - i.credits).reduce((partialSum, a) => partialSum + a, 0);
          if (response.filter(i => i.groupId === g)[0]?.groupName) {

            let obj = { name: response.filter(i => i.groupId === g)[0]?.groupName, grValue: gValue }
            groupInfo.push(obj)
          }
        }
        resultMultipleGroups = resultMultipleGroups + gValue;
        mainClass.currentValue = resultMultipleGroups;
        mainClass.groupsInfo = groupInfo;
      });
    } else if (m?.groups?.length === 1) {
      if (m.name != '') {
        mainClass.name = m.name
      } else {
        let nameForMain = response.find(f => f.groupId === m?.groups[0])?.groupName
        typeof (nameForMain) != 'undefined' ? mainClass.name = nameForMain : mainClass.name = ""
      }
      mainClass.calculateId = m.calculateId;
      var groupInfo = [];
      let gValue = 0;
      if (m.saldo === "credits") {


        let resAccObj;
        if (m.range) {
          gValue = response.filter(i => i.groupId >= m.groups[0] && i.groupId <= m.range[0]).map(i => i.credits - i.debits).reduce((partialSum, a) => partialSum + a, 0);
          resAccObj = response.filter(i => i.groupId >= m.groups[0] && i.groupId <= m.range[0])
        } else {
          gValue = response.filter(i => i.groupId === m.groups[0]).map(i => i.credits - i.debits).reduce((partialSum, a) => partialSum + a, 0);
          resAccObj = response.filter(i => i.groupId === m.groups[0]);
        }
        let aggregatedTransactions = calculatesameAccNumberTransactions(resAccObj);
        aggregatedTransactions.forEach(e => {
          let obj = { name: e?.accName, grValue: parseFloat(e.credits - e.debits) }
          groupInfo.push(obj)
        });
      } else {

        let resAccObj;
        // if(m.range){
        //   gValue = response.filter(i => i.groupId >= m.groups[0] && i.groupId <= m.range[0]).map(i => i.debits - i.credits).reduce((partialSum, a) => partialSum + a, 0);
        //   resAccObj= response.filter(i => i.groupId >= m.groups[0] && i.groupId <= m.range[0])
        // }else{
        gValue = response.filter(i => i.groupId === m.groups[0]).map(i => i.debits - i.credits).reduce((partialSum, a) => partialSum + a, 0);
        resAccObj = response.filter(i => i.groupId === m.groups[0]);
        // }
        let aggregatedTransactions = calculatesameAccNumberTransactions(resAccObj);
        aggregatedTransactions.forEach(e => {
          let obj = { name: e?.accName, grValue: parseFloat(e.debits - e.credits) }
          groupInfo.push(obj)
        });
      }
      mainClass.currentValue = gValue;
      mainClass.groupsInfo = groupInfo;
      // console.log(gValue)
      // mainClass.name = accountingGroup.find(f => f.groupId === gId)?.name;

    } else {
      mainClass.name = m.name;
      mainClass.calculateTotalId = m.calculateTotalId;
      mainClass.calculateId = m.calculateId;
      let totalCalculated = formatedData.filter(f => f.calculateId === m.calculateTotalId).reduce((sum, currentItem) => {
        return sum + currentItem.currentValue;
      }, 0);
      mainClass.currentValue = totalCalculated;
    }
    formatedData.push(mainClass);
    // console.log(mainClass)

    // console.log(mainClass);
  });

  return formatedData;
}



export function testdata(response) { }


